import { types } from "../../types/types";

const initialState = {
  cargada: false,
  loading: false,
  documentacionCargada: false,
  documentacionXSubTipoEfector: [],
  documentacionEfectorFac: [],
  documentacionLegal: []
};

export const contratacionesDocumentacionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.contratacionesSetDocumentacionCargada:
      return {
        ...state,
        documentacionCargada: action.payload,
      };
    case types.contratacionesGetDocumentacionXSubTipoEfector:
      return {
        ...state,
        documentacionXSubTipoEfector: action.payload,
      };
    case types.contratacionesGetDocumentacionEF:
      return {
        ...state,
        documentacionEfectorFac: action.payload,
      };
    case types.contratacionesGetDocumentacionLegal:
      return {
        ...state,
        documentacionLegal: action.payload,
      };
    default:
      return state;
  }
};
